<template>
	<BaseLoading v-if="isLoading" />
	<BannerHighlightLobForm
		v-else
		:is-loading="isLoading"
		:is-edit-mode="true"
		:is-updating="isUpdating"
		:data="data"
		:banner-type="bannerType"
		@onSubmit="handleSubmit"
	/>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import BannerHighlightLobForm from '@/components/BannerHighlightLobForm.vue';
import { BANNER_TYPE } from '../enums/banners';
import { HOMEPAGE_COMPONENTS } from '../enums/homepage';
import { ROUTE_NAME } from '../enums/route';
import { scrollToTop } from '../assets/js/helpers';

export default {
	name: 'BannerHighlightLobEdit',

	components: {
		BannerHighlightLobForm,
	},

	props: {
		bannerType: {
			type: String,
			default: BANNER_TYPE.highlight_lob,
		},
		context: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
			id: Number(this.$route.params.id) || null,
		};
	},

	computed: {
		...mapState('banners', {
			edit: 'edit',
		}),

		...mapGetters({
			getBannerGroupDetail: 'banners/getBannerGroupDetail',
		}),

		isLoading() {
			return this.edit.isLoading;
		},

		isUpdating() {
			return this.edit.isUpdating;
		},

		data() {
			return this.getBannerGroupDetail;
		},
	},

	watch: {
		data(value) {
			if (value && value.name) {
				this.setPageTitle({
					title: value.name,
					isShow: true,
				});
			}
		},
	},

	async created() {
		await this.getBannerGroup({ id: this.$route.params.id, type: this.bannerType });

		if (this.data && this.data.name) {
			this.setPageTitle({
				title: this.data.name,
				isShow: true,
			});
		}

		const breadcrumbTitle = HOMEPAGE_COMPONENTS.BANNER_HIGHLIGHT_LOB.title;
		const breadcrumbRouteName = ROUTE_NAME.BANNER_HIGHLIGHT_LOB_LIST;

		this.addBreadcrumb({
			title: breadcrumbTitle,
			route: {
				name: breadcrumbRouteName,
			},
		});
	},

	methods: {
		...mapActions({
			setPageTitle: 'pageTitle/setPageTitle',
			addBreadcrumb: 'breadcrumb/addBreadcrumb',
			showToast: 'toast/showToast',

			getBannerGroup: 'banners/getBannerGroup',
			updateBannerGroup: 'banners/updateBannerGroup',
		}),

		async handleSubmit(updatedData) {
			try {
				await this.updateBannerGroup({ id: this.id, params: updatedData });
			} finally {
				scrollToTop();
			}
		},
	},
};
</script>
